import { Capacitor } from '@capacitor/core';

export const isMobileApp = (): boolean => {
    return Capacitor.isNativePlatform();
};
